/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import {
  InlineNotification,
  NotificationActionButton
} from 'carbon-components-react';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { sharedMessages } from '../../messages';
import { links } from '../links';
import { MappingStepMessages as messages } from './messages';

interface InvalidResponseMethodWarningProps {
  /**
   *
   */
  invalidResponsesStr: string;
}
export const InvalidResponseMethodWarning = ({
  invalidResponsesStr
}: InvalidResponseMethodWarningProps) => {
  const { formatMessage: t } = useIntl();

  return (
    <div className="InvalidResponseMethodWarning">
      <InlineNotification
        kind="warning"
        lowContrast={true}
        title={
          <FormattedMessage
            {...messages.notificationTitle}
            values={{
              invalidResponses: invalidResponsesStr
            }}
          />
        }
        iconDescription={t(messages.closeWarning)}
        statusIconDescription={t(messages.closeWarning)}
        hideCloseButton={true}
        actions={
          <NotificationActionButton
            onClick={() => window.open(links.learnMore, '_blank')}>
            <FormattedMessage {...sharedMessages.learnMore} />
          </NotificationActionButton>
        }
      />
    </div>
  );
};
